"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = void 0;
const Scanner_1 = require("./Scanner");
const RowParser_1 = require("./RowParser");
const Token_1 = require("./Token");
class Parser {
  static removeBOM(line) {
    // Catches EFBBBF (UTF-8 BOM) because the buffer-to-string
    // conversion translates it to FEFF (UTF-16 BOM)
    if (line && line.charCodeAt(0) === 0xfeff) {
      return line.slice(1);
    }
    return line;
  }
  parserOptions;
  rowParser;
  constructor(parserOptions) {
    this.parserOptions = parserOptions;
    this.rowParser = new RowParser_1.RowParser(this.parserOptions);
  }
  parse(line, hasMoreData) {
    const scanner = new Scanner_1.Scanner({
      line: Parser.removeBOM(line),
      parserOptions: this.parserOptions,
      hasMoreData
    });
    if (this.parserOptions.supportsComments) {
      return this.parseWithComments(scanner);
    }
    return this.parseWithoutComments(scanner);
  }
  parseWithoutComments(scanner) {
    const rows = [];
    let shouldContinue = true;
    while (shouldContinue) {
      shouldContinue = this.parseRow(scanner, rows);
    }
    return {
      line: scanner.line,
      rows
    };
  }
  parseWithComments(scanner) {
    const {
      parserOptions
    } = this;
    const rows = [];
    for (let nextToken = scanner.nextCharacterToken; nextToken !== null; nextToken = scanner.nextCharacterToken) {
      if (Token_1.Token.isTokenComment(nextToken, parserOptions)) {
        const cursor = scanner.advancePastLine();
        if (cursor === null) {
          return {
            line: scanner.lineFromCursor,
            rows
          };
        }
        if (!scanner.hasMoreCharacters) {
          return {
            line: scanner.lineFromCursor,
            rows
          };
        }
        scanner.truncateToCursor();
      } else if (!this.parseRow(scanner, rows)) {
        break;
      }
    }
    return {
      line: scanner.line,
      rows
    };
  }
  parseRow(scanner, rows) {
    const nextToken = scanner.nextNonSpaceToken;
    if (!nextToken) {
      return false;
    }
    const row = this.rowParser.parse(scanner);
    if (row === null) {
      return false;
    }
    if (this.parserOptions.ignoreEmpty && RowParser_1.RowParser.isEmptyRow(row)) {
      return true;
    }
    rows.push(row);
    return true;
  }
}
exports.Parser = Parser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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